<script setup>
import Buttons from '@/components/ui/Buttons.vue';
import CustomsServiceCard from '@/components/cards/CustomsServiceCard.vue';
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>
<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data?.background_color}` : '',
      data?.spacing?.top ? `section--top-${data.spacing.top}` : '',
      data?.spacing?.bottom ? `section--bottom-${data.spacing.bottom}` : '',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div class="customs-services">
        <h2
          class="mb-0 customs-services__title h2 text-center"
          :class="[data?.background_color === 'black' ? 'white' : 'black']"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="data.title"
        ></h2>
        <div class="customs-services__items">
          <template v-for="(item, index) in data.items" :key="item.title">
            <CustomsServiceCard
              :image="item?.image"
              :title="item?.title"
              :description="item?.description"
              :background-color="data?.background_color"
              data-aos="fade-up"
              :data-aos-delay="index >= 1 ? 100 + 100 * index : 100"
            />
          </template>
        </div>
        <Buttons
          v-if="data.buttons && data.buttons.length > 0"
          class="customs-services__buttons"
          :buttons="data?.buttons"
          :background-color="data?.background_color"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          :buttons-prefix-class="'js-button-customs-services'"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.customs-services {
  $parent: &;
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__title {
    margin: 0;
  }
  &__items {
    display: grid;
    gap: 40px;
    @include media-breakpoint-up(sm) {
      column-gap: 16px;
      grid-template-columns: repeat(2, 6fr);
      row-gap: 64px;
    }
    @include media-breakpoint-up(md) {
      grid-template-columns: repeat(3, 4fr);
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(column-gap, 16);
      @include responsive-spacing(row-gap, 64);
    }
  }
  &__buttons {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    @include media-breakpoint-up(sm) {
      flex-direction: row;
      gap: 16px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 16);
    }
  }
}
</style>
